var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "message-square") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,9 C12.552,9 13,9.448 13,10 C13,10.552 12.552,11 12,11 C11.448,11 11,10.552 11,10 C11,9.448 11.448,9 12,9 Z M16,9 C16.552,9 17,9.448 17,10 C17,10.552 16.552,11 16,11 C15.448,11 15,10.552 15,10 C15,9.448 15.448,9 16,9 Z M8,9 C8.552,9 9,9.448 9,10 C9,10.552 8.552,11 8,11 C7.448,11 7,10.552 7,10 C7,9.448 7.448,9 8,9 Z M20,15 C20,15.551 19.551,16 19,16 L8.554,16 C8.011,16 7.477,16.148 7.01,16.428 L4,18.234 L4,5 C4,4.449 4.449,4 5,4 L19,4 C19.551,4 20,4.449 20,5 L20,15 Z M19,2 L5,2 C3.346,2 2,3.346 2,5 L2,20 C2,20.36 2.194,20.693 2.507,20.87 C2.66,20.957 2.83,21 3,21 C3.178,21 3.356,20.953 3.515,20.857 L8.039,18.143 C8.195,18.049 8.373,18 8.554,18 L19,18 C20.654,18 22,16.654 22,15 L22,5 C22,3.346 20.654,2 19,2 L19,2 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-square",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#0D1C2E",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquare);
export default __webpack_public_path__ + "static/media/message-square.ddb8030acb542a40a8f3e70949d3de9e.svg";
export { ForwardRef as ReactComponent };